import React from "react";
import styles from "./whyUs.module.css";
function index({ title, subtitle, content, img }) {
  console.log("content", content);
  return (
    <div className={styles.whyUsWrapper} id="whyus">
      <div id="whyUs" className={styles.headingWrapper}>
        <h2 className="mainHeading">{title}</h2>
        <p className="subHeading">{subtitle}</p>
      </div>
      <div className={styles.contentWrapper}>
        <img src={`${img}`} alt="chart" />

        {/* {content.map((item, i) => (
          <div className={styles.whyUsCards} key={i}>
            <div className={styles.whyUsCard}>
              {console.log("item", item.image)}
              <img src={item.image} alt="experience" />
              <p>{item.paragraph}</p>
            </div>
          </div>
        ))} */}
      </div>
    </div>
  );
}

export default index;
